import { Children } from "react";
import SearchInput from "./SearchInput";
import BackLink from "./BackLink";
import "./TopBar.scss";

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {import('react').JSX.Element}
 */
const TopBarTitle = ({ children }) => (
    <h1 className="plan-manager-top-bar__title">{children}</h1>
);

/**
 * @param {object} props
 * @param {import('react').ReactNode} props.children
 * @returns {import('react').JSX.Element}
 */
const TopBarActions = ({ children }) => (
    <div className="plan-manager-top-bar__actions">{children}</div>
);

/**
 * Plan Manager top bar shell for list toolbars and detail headers.
 * Compose with Search, Back, Title, and Actions subcomponents.
 *
 * @param {object} props
 * @param {"list" | "detail"} [props.variant="list"]
 * @param {string} [props.className]
 * @param {import('react').ReactNode} props.children
 * @returns {import('react').JSX.Element}
 */
const TopBar = ({ variant = "list", className, children }) => {
    let search = null;
    let back = null;
    let title = null;
    let actions = null;
    const middle = [];

    Children.forEach(children, (child) => {
        if (!child) {
            return;
        }

        if (child.type === SearchInput) {
            search = child;
            return;
        }

        if (child.type === BackLink) {
            back = child;
            return;
        }

        if (child.type === TopBarTitle) {
            title = child;
            return;
        }

        if (child.type === TopBarActions) {
            actions = child;
            return;
        }

        middle.push(child);
    });

    const rootClassName = [
        "plan-manager-top-bar",
        `plan-manager-top-bar--${variant}`,
        className,
    ]
        .filter(Boolean)
        .join(" ");

    if (variant === "detail") {
        return (
            <div className={rootClassName}>
                <div className="plan-manager-top-bar__lead">
                    {back}
                    {title}
                </div>
                {actions}
            </div>
        );
    }

    return (
        <div className={rootClassName}>
            {search}
            {middle}
            {actions}
        </div>
    );
};

TopBar.Search = SearchInput;
TopBar.Back = BackLink;
TopBar.Title = TopBarTitle;
TopBar.Actions = TopBarActions;

export default TopBar;
